<template>
  <div :class="`active-step-${showCheckoutView}`">
    <div class="app-order-substitute-esim-wrapper">
      <div class="form-stepper form-stepper-mobile"></div>
      <div class="form-stepper form-stepper-desktop">
        <div class="form-stepper-background">
        </div>
      </div>
      <div class="form-content">
        <SubstituteESimSelection
          v-if="showSelection && showSelectionStep"
          :backLink="backLink"
          :available-device-types="availableDeviceTypes"
          :activeSimType="activeSimType"
        >
          <template v-for="slot in possibleChildSlotsFor('Selection')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </SubstituteESimSelection>

        <!-- Hier werden die Slots durchgereicht, ohne dass das 'ShoppingCart abgeschnitten wird.Damit die Slots aus dem mobilen Warenkorb wiederverwendet werden können.' -->
        <SubstituteESimSummary
          v-if="showSummaryStep"
          :backLink="backLink"
          :successUrlSim="successUrlSim"
          :successUrlEsim="successUrlEsim"
        >
          <template v-for="slot in possibleChildSlotsFor('Summary')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
          <template v-for="slot in possibleChildSlotsFor('ShoppingCart')" v-slot:[`${slot.parent}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </SubstituteESimSummary>
      </div>
      <SimShoppingCartMobileWrapper>
        <template v-for="slot in possibleChildSlotsFor('ShoppingCart')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SimShoppingCartMobileWrapper>
    </div>
  </div>
</template>

<script>
import SubstituteESimSelection, {
  stepName as selectionStepName
} from '@/components/process/generic/SubstituteSimCard/SubstituteESimSelection.vue'
import SubstituteESimSummary, {
  stepName as summaryStepName
} from '@/components/process/generic/SubstituteSimCard/SubstituteESimSummary.vue'
import SimShoppingCartMobileWrapper
from '@/components/process/wrapper/SelfService/SimCard/SimShoppingCartMobileWrapper.vue'

import transaction from '@/mixins/transaction'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import { mapGetters, mapMutations } from 'vuex'
import gql from 'graphql-tag'
import processWrapper from '@/mixins/processWrapper'

export default {
  name: 'OrderSubstituteESimWrapper',
  data () {
    return {
      activeProcess: 'substituteSimCard',
      substituteSimCardOptions: [],
      currentCustomerContract: {}
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'getStatusSimType', 'currentStep', 'showCheckoutView'
    ]),
    showSummaryStep () {
      return this.currentStep === summaryStepName
    },
    showSelection () {
      if (this.getStatusSimType === null) {
        return false
      } else if (this.getStatusSimType === '') {
        return false
      } else {
        return true
      }
    },
    showSelectionStep () {
      return this.currentStep === selectionStepName
    },
    activeSimType () {
      return this.currentCustomerContract?.contract?.simCard.type
    }
  },
  mounted () {
    this.startLoader()
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'setStatusSimType',
      'setSubstituteSimCardOptions'
    ])
  },
  props: {
    backLink: {
      type: String,
      required: true
    },
    availableDeviceTypes: {
      type: String,
      default: ''
    },
    successUrlSim: {
      type: String,
      default: ''
    },
    successUrlEsim: {
      type: String,
      default: ''
    }
  },
  components: {
    SimShoppingCartMobileWrapper,
    SubstituteESimSelection,
    SubstituteESimSummary
  },
  mixins: [

    transaction('contractData'),
    transaction('orderSubstituteSim'),
    processWrapper('showCheckoutView')
  ],
  import: {
    selectionStepName, summaryStepName
  },
  apollo: {
    currentCustomerContract: function () {
      const me = this
      return wrapQuery(
        gql`query contractData {
            currentCustomerContract:
            currentCustomer {
                contract {
                    simCard {
                        type
                    }
               }
            }
        }`, this, 'currentCustomerContract', {}, (response) => {
          const type = response.contract?.simCard?.type
          if (this.getStatusSimType === null || this.getStatusSimType === '') {
            this.setStatusSimType(type)
          }
          this.stopLoader()
        }, { fetchPolicy: 'cache-first' }, (error) => {
          if (typeof error.message !== 'undefined') {
            const data = {
              type: 'technical',
              message: error.message
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.stopLoader()
          me.openErrorToast()
        }
      )
    },
    substituteSimCardOptions: function () {
      const me = this
      return wrapQuery(
        gql`query orderSubstituteSim {
          substituteSimCardOptions {
            name,
            price,
            productNumber,
            productPrice,
            shippingCosts,
            total,
            type,
            possibleActivationSettings
          }
        }`, this, 'substituteSimCardOptions', {}, (response) => {
          me.setSubstituteSimCardOptions(response)
          this.stopLoader()
        },
        {}, (error) => {
          if (typeof error.message !== 'undefined') {
            const data = {
              type: 'technical',
              message: error.message
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.stopLoader()
          me.openErrorToast()
        }
      )
    }
  }
}
</script>
